export default class UpdateVesselPositionData {
  constructor(latitude, longitude, date) {
    this.latitude = latitude;
    this.longitude = longitude;
    this.date = date;
  }
}
